import React, { useEffect } from 'react';
import FirstValueBanner from './FirstValueBanner';
import ValueFirstDatasection from './ValueFirstDatasection';
import BookValueFirst from './BookValueFirst';
import Valuessecondsection from './Valuessecondsection';
import Valuefirststandfor from './Valuefirststandfor';
import ValueFirstbulbsection from './ValueFirstbulbsection';
const FirstVale = () => {
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []); // Empty dependency array ensures it only runs once when the component mounts
              // Scroll to the top of the page when the component mounts
     
    return (
        <div style={{background:"#fff"}}>
            <FirstValueBanner />
            <ValueFirstDatasection />
            <BookValueFirst />
            <Valuessecondsection />
            {/* <Valuefirststandfor /> */}
            <ValueFirstbulbsection />
        </div>
    );
};

export default FirstVale;
